import React from "react";
import PropTypes from "prop-types";
import {
  Grid,
  MenuItem,
  Checkbox,
  FormControlLabel,
  Tooltip,
  Button,
  TextField,
  Box,
  Typography,
  darken,
  Dialog,
  DialogContent,
  DialogActions,
} from "@mui/material";
import UploadFile from "@mui/icons-material/UploadFile";
import InputText from "../../Fields/InputText";
import debounce from "lodash.debounce";

import "../css/Identification.css";
import InputDate from "../../Fields/InputDate";
import { format, isValid } from "date-fns";

const socialSecurityNumberCountries = ["se", "dk", "no", "fi"];
const formColor = { hcs: "#273A60", arjo: "#0F5376" };

export default class CustomerInformationIdentification extends React.Component {
  static propTypes = {
    idNumber: PropTypes.string,
    customerInformation: PropTypes.object,
    formInformation: PropTypes.object,
    labels: PropTypes.object,
    params: PropTypes.object,
    extraFiles: PropTypes.array,
    changeHandler: PropTypes.func,
    checkHandler: PropTypes.func,
    addExtraFiles: PropTypes.func,
    removeExtraFiles: PropTypes.func,
    formType: PropTypes.string,
    productsValues: PropTypes.object,
  };

  state = {
    idNumber: false,
    dateOfBirth: socialSecurityNumberCountries.includes(
      this.props.params.lang.toLowerCase(),
    ),
    socialSecurityNumber: !socialSecurityNumberCountries.includes(
      this.props.params.lang.toLowerCase(),
    ),
    legalSignatoryModalOpen: false,
  };

  componentDidMount() {
    let newState = this.state;
    for (let key in newState) {
      if (
        this.props.customerInformation[key] !== undefined &&
        this.props.customerInformation[key] !== "" &&
        this.props.customerInformation[key] !== null
      ) {
        newState[key] = true;
      }
    }
    if (this.props.params.lang !== "at") {
      newState["idNumber"] = true;
    }
    if (this.props.formInformation.customer === "Business") {
      newState["idNumber"] = true;
      newState["socialSecurityNumber"] = true;
      newState["dateOfBirth"] = true;
      this.isFinished();
    }
    this.setState(newState);
  }

  isFinished = debounce(() => {
    // Skip checking legalSignatoryModalOpen and any other modal-related states
    const { legalSignatoryModalOpen, ...statesToCheck } = this.state;

    const data = {
      identificationFinished: Object.values(statesToCheck).every((finished) => {
        return finished;
      }),
    };
    this.props.changeHandler(data);
  }, 250);

  handleChange = (value, id) => {
    let newState = this.state;
    let data = {};

    if (id === "dateOfBirth" && isValid(value)) {
      const formattedDate = value ? format(value, "dd/MM/yyyy") : "";
      data["socialSecurityNumber"] = formattedDate;
      newState["dateOfBirth"] = true;
    }
    data[id] = value;
    this.props.changeHandler(data);
    this.isFinished();
    this.setState(newState);
  };

  handleChecked = (event) => {
    if (
      event.target.id === "legal_signatory_provided" &&
      !this.props.formInformation.legalSignatoryChecked
    ) {
      this.setState({ legalSignatoryModalOpen: true });
      return;
    }

    this.props.checkHandler(event);
  };

  handleCloseLegalSignatoryModal = () => {
    this.setState({ legalSignatoryModalOpen: false });
  };

  handleConfirmLegalSignatory = () => {
    this.setState({ legalSignatoryModalOpen: false });
    this.props.checkHandler({
      target: {
        id: "legal_signatory_provided",
      },
    });
  };

  handleAddfile = (event) => {
    let files = [];
    const allowedTypes = ["image/jpeg", "application/pdf", "image/png"];
    const maxFileSize = 5 * 1024 * 1024;
    for (let i = 0; i < event.target.files.length; i++) {
      if (!allowedTypes.includes(event.target.files[i].type)) {
        alert(this.props.labels.wrong_filetype);
        continue;
      }
      if (event.target.files[i].size > maxFileSize) {
        alert(this.props.labels.large_file);
        continue;
      }
      if (files.length + this.props.extraFiles.length > 4) {
        alert(this.props.labels.too_many_files);
        continue;
      }
      if (
        !this.props.extraFiles.some(
          (file) => file.name === event.target.files[i].name,
        )
      ) {
        let element = event.target.files[i];
        files.push(element);
      } else {
        alert(this.props.labels.duplicate_filename);
      }
    }
    this.props.addExtraFiles(files);
    event.target.value = null;
    this.isFinished();
  };

  handleRemoveFile = (file) => {
    this.props.removeExtraFiles(file);
  };

  render() {
    const showRepurchase = false;
    // this.props.params.formType.toLowerCase() === "leaseplus" &&
    // this.props.params.comp.toLowerCase() === "hcs" &&
    // Object.values(this.props.productsValues).some(
    //   (obj) =>
    //     obj.name &&
    //     (obj.name.toLowerCase().includes("automower") ||
    //       obj.name.toLowerCase().includes("am"))
    // );
    return (
      <Grid container spacing={2}>
        {this.props.formInformation.customer === "Private" && (
          <>
            {this.props.params.lang.toLowerCase() !== "at" ? null : (
              <Grid item xs={4}>
                <Tooltip
                  title={
                    <span style={{ fontSize: "12px" }}>
                      {this.props.labels.tooltip_id_select}
                    </span>
                  }
                  placement="top"
                >
                  <TextField
                    className="id_select"
                    value={this.props.customerInformation.idType}
                    name={"idType"}
                    onChange={(event) => {
                      this.handleChange(event.target.value, event.target.name);
                    }}
                    select
                    label={this.props.labels.label_id_type + " *"}
                  >
                    {this.props.labels.id_select.map((option) => {
                      return (
                        <MenuItem value={option} key={option} id="test">
                          {option}
                        </MenuItem>
                      );
                    })}
                  </TextField>
                </Tooltip>
              </Grid>
            )}
            {this.props.params.lang.toLowerCase() !== "at" ? null : (
              <Grid item xs={4}>
                <InputText
                  id="idNumber"
                  label={this.props.labels.label_id_number}
                  changeHandler={this.handleChange}
                  defaultValue={this.props.customerInformation.idNumber}
                  tooltip={this.props.labels.tooltip_label_id_number}
                  required={true}
                  sx={{ width: "100%" }}
                  className={
                    this.props.formInformation.showInvalid &&
                    !this.state.idNumber
                      ? "invalid"
                      : ""
                  }
                />
              </Grid>
            )}
            {this.props.params.lang.toLowerCase() !== "at" ? null : (
              <Grid item xs={4}>
                <Tooltip
                  title={
                    <span style={{ fontSize: "12px" }}>
                      {this.props.labels.tooltip_pep}
                    </span>
                  }
                  placement="top"
                >
                  <TextField
                    className="id_select"
                    value={this.props.customerInformation.pep}
                    name={"pep"}
                    onChange={(event) => {
                      this.handleChange(event.target.value, event.target.name);
                    }}
                    select
                    label={this.props.labels.pep_label + " *"}
                  >
                    {this.props.labels.pep.map((option) => {
                      return (
                        <MenuItem value={option} key={option}>
                          {option}
                        </MenuItem>
                      );
                    })}
                  </TextField>
                </Tooltip>
              </Grid>
            )}
            <Grid item xs={6}>
              {socialSecurityNumberCountries.includes(
                this.props.params.lang.toLowerCase(),
              ) ? (
                <InputText
                  id={"socialSecurityNumber"}
                  label={this.props.labels.social_security_number}
                  changeHandler={this.handleChange}
                  defaultValue={
                    this.props.customerInformation.socialSecurityNumber
                  }
                  required={true}
                  sx={{ width: "100%" }}
                  tooltip={this.props.labels.tooltip_social_security_number}
                  className={
                    this.props.formInformation.showInvalid &&
                    !this.state.socialSecurityNumber
                      ? "invalid"
                      : ""
                  }
                />
              ) : (
                <>
                  {this.props.params.lang === "fr" && (
                    <div
                      style={{
                        marginBottom: "10px",
                        fontSize: "large",
                        fontWeight: "bold",
                      }}
                    >
                      Date de naissance du client*
                    </div>
                  )}
                  <InputDate
                    id={"dateOfBirth"}
                    label={
                      this.props.params.lang === "fr"
                        ? ""
                        : this.props.labels.social_security_number
                    }
                    changeHandler={this.handleChange}
                    date={this.props.customerInformation.dateOfBirth}
                    tooltip={this.props.labels.tooltip_date_of_birth}
                    required={this.props.params.lang === "fr" ? false : true}
                    sx={{ width: "100%" }}
                    maxDate={
                      new Date(
                        new Date().setFullYear(new Date().getFullYear() - 18),
                      )
                    }
                    defaultCalendarMonth={
                      new Date(
                        new Date().setFullYear(new Date().getFullYear() - 18),
                      )
                    }
                    className={
                      this.props.formInformation.showInvalid &&
                      !this.state.dateOfBirth
                        ? "invalid"
                        : ""
                    }
                  />
                </>
              )}
            </Grid>
            <Grid item xs={12}>
              <Tooltip
                title={
                  <span style={{ fontSize: "12px" }}>
                    {this.props.labels.tooltip_id_check}
                  </span>
                }
                placement="top"
              >
                <FormControlLabel
                  className="id_checked"
                  control={
                    <Checkbox
                      id="id_checked"
                      checked={this.props.formInformation.idChecked}
                      onChange={this.handleChecked}
                    />
                  }
                  label={this.props.labels.id_check + " *"}
                  sx={{ width: "100%" }}
                />
              </Tooltip>
            </Grid>
            {showRepurchase ? (
              <Grid item xs={12}>
                <Tooltip
                  title={
                    <span style={{ fontSize: "12px" }}>
                      {this.props.labels.tooltip_repurchase}
                    </span>
                  }
                  placement="top"
                >
                  <TextField
                    className="repurchase_select"
                    value={this.props.customerInformation.repurchase}
                    name={"repurchase"}
                    onChange={(event) => {
                      this.handleChange(event.target.value, event.target.name);
                    }}
                    select
                    label={this.props.labels.repurchase_label}
                    helperText={this.props.labels.repurchase_helper}
                  >
                    {[
                      this.props.labels.dealer_repurchase,
                      this.props.labels.hcs_repurchase,
                    ].map((option) => {
                      return (
                        <MenuItem value={option} key={option} id="test">
                          {option}
                        </MenuItem>
                      );
                    })}
                  </TextField>
                </Tooltip>
              </Grid>
            ) : null}
          </>
        )}
        {(this.props.params.formType.toLowerCase() === "flexpro" ||
          this.props.params.formType.toLowerCase() === "upcare") && (
          <Grid item xs={12}>
            <>
              <FormControlLabel
                className="id_checked"
                control={
                  <Checkbox
                    id="id_checked"
                    checked={this.props.formInformation.idChecked}
                    onChange={this.handleChecked}
                  />
                }
                label={this.props.labels.id_check + " *"}
                sx={{ width: "100%" }}
              />
              <FormControlLabel
                className="legal_signatory_provided"
                control={
                  <Checkbox
                    id="legal_signatory_provided"
                    checked={this.props.formInformation.legalSignatoryChecked}
                    onChange={this.handleChecked}
                  />
                }
                label={this.props.labels.signatory_checkbox + "*"}
                sx={{ width: "100%" }}
              />
              <Dialog
                open={this.state.legalSignatoryModalOpen}
                onClose={this.handleCloseLegalSignatoryModal}
                maxWidth={false}
                PaperProps={{
                  sx: {
                    width: "900px",
                    maxWidth: "calc(100% - 48px)",
                    minHeight: "570px",
                    borderRadius: "6px",
                  },
                }}
              >
                <DialogContent
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    px: { xs: 3, sm: 9 },
                    pt: 5.5,
                    pb: 3,
                  }}
                >
                  <Typography
                    variant="h4"
                    component="h2"
                    sx={{
                      mb: 3,
                      fontWeight: 700,
                      fontSize: { xs: "24px", sm: "30px" },
                      lineHeight: 1.15,
                      textAlign: "center",
                      color: "#000",
                    }}
                  >
                    {this.props.labels.signatory_dialog_title}
                    {/* Information regarding Signatory/Signatories */}
                  </Typography>
                  <Typography
                    sx={{
                      mb: 3,
                      // maxWidth: "660px",
                      fontSize: "15px",
                      lineHeight: 1.15,
                      textAlign: "center",
                      color: "#111",
                    }}
                  >
                    {this.props.labels.signatory_dialog_header}
                  </Typography>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 4,
                      width: "100%",
                      maxWidth: "680px",
                    }}
                  >
                    {/* Loop through all signatories */}
                    {Object.entries(
                      this.props.customerInformation.signatories || {},
                    ).map(([key, signatory]) => (
                      <Box
                        key={key}
                        sx={{
                          px: 2,
                          py: 1.5,
                          display: "flex",
                          flexDirection: "column",
                          borderRadius: "6px",
                          backgroundColor: "#ddd",
                          color: "#000",
                          fontSize: { xs: "20px", sm: "24px" },
                          lineHeight: 1.08,
                          letterSpacing: 0,
                        }}
                      >
                        <div>
                          {this.props.labels.label_customer_name + ": "}
                          {signatory.nameSignatory}
                        </div>
                        <div>
                          {this.props.labels.date_of_birth + ": "}
                          {signatory.dateOfBirthCustomerSignatory
                            ? new Date(
                                signatory.dateOfBirthCustomerSignatory,
                              ).toLocaleDateString("sv-SE")
                            : signatory.socialSecurityNumberCustomerSignatory}
                        </div>
                        <div>
                          {this.props.labels.label_email + ": "}
                          {signatory.emailSignatory}
                        </div>
                      </Box>
                    ))}
                  </Box>
                </DialogContent>
                <DialogActions
                  sx={{
                    flexDirection: { xs: "column", sm: "row" },
                    alignItems: "flex-end",
                    justifyContent: "space-between",
                    gap: 2,
                    px: { xs: 3, sm: 10 },
                    pb: 3,
                  }}
                >
                  <Typography
                    sx={{
                      maxWidth: "550px",
                      fontSize: "13px",
                      lineHeight: 1.2,
                      color: "#5f5f5f",
                      alignSelf: { xs: "stretch", sm: "flex-end" },
                    }}
                  >
                    {this.props.labels.signatory_dialog_footer}
                  </Typography>
                  <Button
                    onClick={this.handleConfirmLegalSignatory}
                    variant="contained"
                    sx={{
                      minWidth: "144px",
                      minHeight: "56px",
                      borderRadius: "8px",
                      backgroundColor: "#dd5200",
                      color: "white",
                      fontSize: "28px",
                      fontWeight: 700,
                      lineHeight: 1,
                      textTransform: "none",
                      "&:hover": {
                        backgroundColor: darken("#dd5200", 0.12),
                      },
                    }}
                  >
                    {this.props.labels.confirm}
                  </Button>
                </DialogActions>
              </Dialog>
            </>
          </Grid>
        )}
        {/*<Grid item xs={12}>
          <Box textAlign="left">
            <Button
              variant="contained"
              component="label"
              sx={{
                backgroundColor:
                  formColor[this.props.params.comp.toLowerCase()],
                marginBottom: 0.5,
              }}
              startIcon={<UploadFile />}
            >
              {this.props.labels.upload_extra_files}
              <input
                type="file"
                accept="image/jpeg, application/pdf, image/png"
                multiple
                hidden
                onChange={this.handleAddfile}
              />
            </Button>
            <Typography variant="caption" display="block" gutterBottom>
              <strong>{this.props.labels.must_attach}</strong>
            </Typography>
          </Box>
          <div id="fileContents">
            {this.props.extraFiles.length > 0 && (
              <p>{this.props.labels.uploaded_files} </p>
            )}
            {this.props.extraFiles.map((file) => {
              return (
                <Button
                  variant="text"
                  className="file"
                  id={file.name}
                  key={file.name}
                  onClick={() => {
                    this.handleRemoveFile(file);
                  }}
                >
                  {file.name}
                </Button>
              );
            })}
          </div>
        </Grid>*/}
        {/*this.props.params.lang === "fr" && (
          <div style={{ color: "red", fontSize: "large", fontWeight: "bold" }}>
            <p>
              <span>
                Attention ! Le client s'inscrit au paiement par prélèvement
                automatique via le lien sur la première facture. Ne pas envoyer
                le RIB au client.
              </span>
            </p>
            {this.props.params.formType === "leaseplus" && (
              <p>
                <span>
                  La facture d'électricité ou de téléphone du client doit être
                  téléchargée pour pouvoir envoyer la demande à HCS.
                </span>
              </p>
            )}
          </div>
        )*/}
      </Grid>
    );
  }
}
